import React, { Component } from 'react'
import { connect } from 'react-redux'

// COMPONENTS
import { Container } from 'components'
import PaymentRouter from '../../routers/PaymentRouter'
import PaymentFooter from '../../components/PaymentFooter/'

class Payment extends Component {
  render() {
    return (
      <div className="Payment">
        <Container>
          <PaymentRouter/>
          <PaymentFooter/>
        </Container>
      </div>
    )
  }
}


const mapStateToProps = state => {
  return {
    isAuth: state.auth.isAuth,
    userData: state.auth.userData,
  }
}

export default connect(mapStateToProps)(Payment)